import { useEffect } from "react";

export function useSEO({ title, description, canonical }) {
  useEffect(() => {
    if (title) document.title = title.includes("KLYROO") ? title : `${title} | KLYROO`;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (m) m.setAttribute("content", description);
    }
    let link = null;
    if (canonical) {
      link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", `${window.location.origin}${canonical}`);
    }
    return () => {
      document.title = "KLYROO — AI. Gaming. Technology. Explained.";
      if (link) link.remove();
    };
  }, [title, description, canonical]);
}
